import type { CityConfig } from "../city-template/types";

export const ozarkMOConfig: CityConfig = {
  city: "Ozark",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "ozark-mo",
  route: "/ozark-mo",
  title: "Emergency Passport Ozark, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Ozark, MO — as fast as 24 hours. Serving Christian County and the Springfield metro. A+ BBB rated registered State Dept. courier serving Ozark, Nixa, Sparta, and the Ozark foothills. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Ozark, MO",
  heroSubtitle: "Ozark foothills anniversary trip to Rome in 5 days? Business trip to London and your passport is expired? Christian County family vacation to Costa Rica needs fast documents? We help Ozark residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Ozark%20Missouri%20Christian%20County%20Ozark%20foothills%20suburban%20Springfield%20metropolitan%20area%20rolling%20green%20hills%20Finley%20River%20scenic%20landscape%20historic%20downtown%20square%20midwestern%20river%20town%20tree%20lined%20streets%20warm%20sunset%20light%20professional%20drone%20photography%20Heartland%20charm&width=1800&height=700&seq=ozark-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Ozark Missouri Christian County rolling hills and Finley River landscape at sunset",
  geoPosition: "37.0209;-93.2060",
  geoPlacename: "Ozark, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 550 miles northeast of Ozark via I-44/I-55",
  },
  nearbyCitiesZips: [
    { name: "Ozark", zips: "65721" },
    { name: "Springfield", zips: "65801–65899" },
    { name: "Nixa", zips: "65714" },
    { name: "Sparta", zips: "65753" },
    { name: "Rogersville", zips: "65742" },
    { name: "Clever", zips: "65631" },
    { name: "Highlandville", zips: "65669" },
    { name: "Oldfield", zips: "65720" },
    { name: "Chadwick", zips: "65629" },
    { name: "Bruner", zips: "65620" },
    { name: "Billings", zips: "65610" },
    { name: "Republic", zips: "65738" },
    { name: "Battlefield", zips: "65619" },
    { name: "Fremont Hills", zips: "65714" },
    { name: "Branson", zips: "65615, 65616" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Christian County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Ozark Foothills Hub", desc: "Serving Ozark, Nixa, Sparta, and Christian County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Springfield, MO", route: "/springfield-mo" },
    { name: "Fast passport renewal in Nixa, MO", route: "/nixa-mo" },
    { name: "Emergency passport help in Joplin, MO", route: "/joplin" },
    { name: "Urgent passport services in Branson, MO", route: "/columbia-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Kansas City, MO", route: "/kansas-city" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Ozark remotely via secure courier. We do not have a walk-in office in Ozark — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Christian County and the Springfield metro.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Christian County including Ozark, Nixa, Sparta, Clever, and surrounding communities",
  serviceAreaIntro: "From the historic Ozark square and the Finley River to the growing suburbs of Nixa and the rural charm of Sparta, from the foothills of the Ozark Mountains to the Springfield metro — Fast Passport Center serves the entire Christian County and southwest Missouri region. We regularly help travelers from Ozark, Nixa, and Sparta get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Ozark neighborhoods and the surrounding Christian County area including Springfield, Nixa, Sparta, Rogersville, Clever, and Republic. If you are anywhere in Christian County or the Springfield metro, we have you covered.",
  howItWorksIntro: "Most Ozark travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Ozark travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Ozark and Christian County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Ozark? Here are the most common ones we hear from Christian County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ozark travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Jessica H.",
      location: "Ozark, MO",
      rating: 5,
      text: "We booked a last-minute Ireland trip and realized my passport was expired with 4 days to spare. Fast Passport Center got my renewal in 28 hours. From the Finley River to the Cliffs of Moher in a week — mind-blowing service!",
      service: "Passport Renewal",
    },
    {
      name: "Doug L.",
      location: "Ozark, MO",
      rating: 5,
      text: "Emergency corporate travel to Singapore with 3 days notice. The dedicated agent kept me informed daily and handled every detail. Passport arrived Friday, flight was Sunday. Absolutely clutch for Ozark business travelers.",
      service: "Emergency Passport",
    },
    {
      name: "Megan R.",
      location: "Nixa, MO",
      rating: 5,
      text: "Both of our kids needed first-time passports for a Disney Paris vacation. Fast Passport Center walked us through the child passport process step by step. All done in 4 days. Christian County families — this is the real deal!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "ozark-1",
      name: "Ozark Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "102 N 2nd St",
      city: "Ozark",
      state: "MO",
      zip: "65721",
      phone: "(417) 581-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Ozark",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ozark facility near the historic square. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "ozark-2",
      name: "Christian County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "100 W Church St",
      city: "Ozark",
      state: "MO",
      zip: "65721",
      phone: "(417) 581-6372",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Ozark Courthouse",
      website: "https://www.christiancountymo.gov",
      websiteLabel: "Christian County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "ozark-3",
      name: "Nixa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 W Mount Vernon St",
      city: "Nixa",
      state: "MO",
      zip: "65714",
      phone: "(417) 725-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Ozark",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Nixa area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ozark-4",
      name: "Springfield Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 W Chestnut Expy",
      city: "Springfield",
      state: "MO",
      zip: "65802",
      phone: "(417) 864-2101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Ozark",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the region. Full passport services and extended hours available.",
      icon: "ri-mail-line",
    },
    {
      id: "ozark-5",
      name: "Sparta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 Main St",
      city: "Sparta",
      state: "MO",
      zip: "65753",
      phone: "(417) 634-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southeast of Ozark",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sparta area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Ozark photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Christian County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Ozark applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Christian County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Ozark travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Ozark." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ozark address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Ozark before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Ozark for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Ozark?", a: "Fast Passport Center offers fast passport renewal in Ozark in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Ozark?", a: "The nearest regional passport agency to Ozark is the Chicago Passport Agency, approximately 550 miles northeast via I-44/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Ozark without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Ozark?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Ozark — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Christian County and southwest Missouri residents." },
    { q: "Do you serve the entire Christian County area?", a: "Absolutely. Fast Passport Center serves the entire Christian County area including Ozark, Nixa, Sparta, Clever, and surrounding communities. Our courier service works seamlessly from any address in Christian County or the Springfield metro." },
    { q: "Can I expedite a child passport in Ozark?", a: "Yes. Fast Passport Center expedites child passports in Ozark for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Christian County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Ozark with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Ozark", address: "2000 W Marler Ln, Ozark, MO 65721", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Nixa", address: "100 N Massey Blvd, Nixa, MO 65714", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Springfield", address: "3050 S Campbell Ave, Springfield, MO 65807", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Republic", address: "1150 US-60, Republic, MO 65738", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Ozark License Office",
      address: "106 N 2nd Ave, Ozark, MO 65721",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Ozark residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Nixa License Office",
      address: "200 W Mt Vernon St, Nixa, MO 65714",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Nixa area. REAL ID available.",
      featured: false,
    },
    {
      name: "Missouri DOR — Springfield License Office",
      address: "149 Park Central Square, Springfield, MO 65806",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Main Greene County location. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SGF",
      name: "Springfield-Branson National Airport",
      distance: "25 miles north of Ozark",
      address: "2300 N Airport Blvd, Springfield, MO 65802",
      note: "Major airport for southwest Missouri with direct flights to major hubs. About 35 minutes from Ozark via US-65.",
      flightUrl: "https://www.flyspringfield.com/",
      flightLabel: "SGF Airport",
      featured: true,
    },
    {
      code: "XNA",
      name: "Northwest Arkansas National Airport",
      distance: "95 miles southwest of Ozark",
      address: "1 Airport Blvd, Bentonville, AR 72712",
      note: "Regional airport in northwest Arkansas. About 1 hour 35 minutes from Ozark via I-49.",
      flightUrl: "https://www.flyxna.com/",
      flightLabel: "XNA Airport",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "215 miles northeast of Ozark",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 3 hours 15 minutes from Ozark via I-44.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};